import { render, staticRenderFns } from "./VideoScreen.vue?vue&type=template&id=11876b5d&"
import script from "./VideoScreen.vue?vue&type=script&lang=js&"
export * from "./VideoScreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports